import apiService from '../apiService';

const emailUsage = {
  // Monthly email allowance: how much is used, and how much campaigns may still
  // use. Read by the settings integrations card and the mass-mail dashboard.
  async getEmailUsage() {
    try {
      const response = await apiService.get('/settings/email-usage');
      return response.data;
    } catch (error) {
      throw error?.response?.data || error;
    }
  },
};

export default emailUsage;
